import Actions from 'actions';

const initialState = Object.freeze({});

function deleteUserImage(state = initialState, action) {
  switch (action.type) {
    case Actions.DELETE_USER_IMAGE_REQUEST:
    case Actions.DELETE_USER_IMAGE_SUCCESS:
      return initialState;
    case Actions.DELETE_USER_IMAGE_FAIL:
      return {
        ...initialState,
        error: action.error,
      };
    default:
      return state;
  }
}

export default deleteUserImage;
